import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { numberFlag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { rawRequest, request } from './common.js';

export async function tokensCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'list';
  switch (action) {
    case 'list':
      return request(args, Methods.Tokens);
    case 'history': {
      const limit = numberFlag(args.flags, 'limit') ?? 20;
      if (!Number.isInteger(limit) || limit < 1 || limit > 500) {
        throw new CliError('--limit must be an integer between 1 and 500', ExitCode.Usage);
      }
      const data = await rawRequest<unknown>(args, Methods.TokensHistory);
      return { data: limitHistory(data, limit) };
    }
    default:
      throw new CliError(`Unknown tokens action "${action}"`, ExitCode.Usage);
  }
}

function limitHistory(value: unknown, limit: number): unknown {
  if (Array.isArray(value)) {
    return {
      entries: value.slice(0, limit),
      total: value.length,
      truncated: value.length > limit,
    };
  }
  if (!value || typeof value !== 'object') return value;
  const record = value as Record<string, unknown>;
  if (!Array.isArray(record.entries)) return value;
  return {
    ...record,
    entries: record.entries.slice(0, limit),
    total: record.entries.length,
    truncated: record.entries.length > limit,
  };
}
